import voucherService from 'services/voucherService';
import * as actionTypes from './actionTypes';

export const fetchingVoucherBalance = () => {
  return dispatch => {
    voucherService
      .getVoucherBalance()
      .then(data => {
        dispatch(successFetchingVoucherBalance(data));
      })
      .catch(err => console.log(err));
  };
};

const successFetchingVoucherBalance = data => {
  return {
    type: actionTypes.VOUCHER_BALANCE_SUCCESS,
    payload: data,
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/VoucherBalance.js